module.exports = __webpack_public_path__ + "img/118.57f0e935.jpg";